module.exports = __webpack_public_path__ + "static/img/hct1.5a27abc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hct/hct1.jpg
// module id = Pc+T
// module chunks = 0